import { NativeSelect, NativeSelectOption } from '@worldcoo/ui/components/native-select';
import type { PortalLocale } from '@worldcoo/monolith/portals';
import { Flag } from '@/lib/country-flags';
import { useTranslation } from '@/lib/i18n';
import { cn } from '@worldcoo/ui/lib/utils';

const languageOptions: { value: PortalLocale; label: string }[] = [
	{ value: 'ca', label: 'Català' },
	{ value: 'de', label: 'Deutsch' },
	{ value: 'en', label: 'English' },
	{ value: 'es', label: 'Español' },
	{ value: 'eu', label: 'Euskera' },
	{ value: 'fr', label: 'Français' },
	{ value: 'gl', label: 'Galego' },
	{ value: 'it', label: 'Italiano' },
	{ value: 'nl', label: 'Nederlands' },
	{ value: 'pt', label: 'Português' },
];

export function NgoLanguageSelect({
	className,
	variant = 'inline',
}: {
	className?: string;
	variant?: 'inline' | 'field';
}) {
	const { language, changeLanguage } = useTranslation();
	const isField = variant === 'field';

	return (
		<div className={cn('flex items-center gap-2', isField ? 'w-full' : 'gap-1.5', className)}>
			<Flag locale={language} className="pointer-events-none size-5 shrink-0" />
			<NativeSelect
				className={
					isField
						? 'flex-1 [&]:w-full [&_select]:h-10 [&_select]:rounded-md [&_select]:text-base'
						: '[&_select]:border-none [&_select]:bg-transparent [&_select]:text-sm [&_select]:shadow-none'
				}
				name="ngo-language-select"
				value={language}
				onChange={(e) => {
					const value = languageOptions.find((o) => o.value === e.target.value);
					if (value) changeLanguage(value.value);
				}}
			>
				{languageOptions.map(({ value, label }) => (
					<NativeSelectOption key={value} value={value}>
						{label}
					</NativeSelectOption>
				))}
			</NativeSelect>
		</div>
	);
}
